<template>
  <div class="DateTicket">
    <div class="content">
      <div class="name">
        {{ ticket.name }}
        <popover
          effect="fade"
          ref="popover"
          class="TicketPopoverContainer"
          placement="bottom"
          title=""
          v-if="ticket.description_long !== ''"
        >
          <template v-slot:title></template>
          <template v-slot:content>
            <div class="popoverContent" v-html="ticket.description_long"></div>
            <div class="popoverActions">
              <button @click.prevent="togglePopover()">
                <Icon icon="close"></Icon>
              </button>
            </div>
          </template>
          <button
            class="btn roundButton btn-secondary"
            @click.prevent=""
            v-if="ticket.description_long !== ''"
          >
            <icon class="iconInfo" icon="info"></icon>
          </button>
        </popover>
      </div>
      <div class="description" v-if="ticket.description_short !== ''">
        {{ ticket.description_short }}
      </div>
    </div>
    <div class="formInputs">
      <div class="price">
        <template v-if="!ticket.family || ticket.price !== '0'">{{
          formatCurrency(ticket.price)
        }}</template>
      </div>
      <NumberInputWithButtons
        v-if="typeof ticket.subtickets === 'undefined' || ticket.family !== true"
        :max="maxTicketsForSchedule"
        :min="0"
        v-model="ticketCount"
      />
    </div>
    <div
      class="subTickets"
      v-if="typeof ticket.subtickets !== 'undefined' && ticket.family === true"
    >
      <SubTicket
        class="subTicket"
        :subTicket="subTicket"
        :ticketId="parseInt(ticket.id, 10)"
        :key="subTicket.id"
        v-for="subTicket in ticket.subtickets"
      >
      </SubTicket>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import popover from '../Vuestrap-TemporaryFix/Popover.vue';
import formater from '../../lib/formater';
import Icon from '../Icon.vue';
import NumberInputWithButtons from '../Form/NumberInputWithButtons.vue';
import SubTicket from './SubTicket.vue';

export default {
  name: 'DateTicket',
  components: {
    NumberInputWithButtons,
    Icon,
    popover,
    SubTicket,
  },
  computed: {
    ...mapState({
      form: (state) => state.tickets.form,
      dateTime: (state) => state.tickets.form.time,
    }),
    orderedSubTickets() {
      const orderedSubTickets = this.ticket.sub_tickets.slice();
      return orderedSubTickets.sort(
        (a, b) => parseInt(a.sequence_no, 10) < parseInt(b.sequence_no, 10)
      );
    },
    maxTicketsForSchedule() {
      let max = false;
      if (typeof this.ticket.schedule !== 'undefined') {
        let schedule = this.ticket.schedule.find((s) => s.datetime === this.dateTime);
        if (typeof schedule !== 'undefined') {
          max = schedule.max_tickets;
        } else {
          // Since doesTicketContainSelectedTime has already been tested
          [schedule] = this.ticket.schedule;
          max = schedule.max_tickets;
        }
      }
      if (parseInt(this.ticket.mode, 10) === 3) {
        max = parseInt(this.ticket.max_tickets, 10);
      }
      if (max !== false) {
        return max;
      }
      return undefined;
    },
    ticketCount: {
      get() {
        const ticket = this.form.tickets[this.ticket.id];
        if (typeof ticket === 'undefined') {
          this.setFormTicketCount({ id: this.ticket.id, count: 0 });
          return this.form.tickets[this.ticket.id].count;
        }
        const v = ticket.count;
        if (Number.isNaN(v)) {
          return 0;
        }
        return v;
      },
      set(v) {
        this.setFormTicketCount({ id: this.ticket.id, count: v });
      },
    },
  },
  props: {
    ticket: { required: true },
  },
  methods: {
    ...mapActions({
      setFormTicketCount: 'tickets/setFormTicketCount',
    }),
    formatCurrency(val) {
      return formater.currency(val);
    },
    togglePopover() {
      // not fancy but works. trigger toggle on child
      this.$refs.popover.toggle();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';

.content {
  @extend .col-sm-7;
  @extend .col-xs-12;
}
.formInputs,
.values {
  @extend .col-sm-5;
  @extend .col-xs-10;
  @extend .col-xs-offset-1;
  @extend .col-sm-offset-0;
  @media screen and (max-width: $screen-sm) {
    margin-top: $sp;
  }

  .price {
    white-space: nowrap;
    text-align: center;
  }
}
.name,
.price {
  font-weight: 600;
}
.priceFamily {
  @extend .col-sm-5;
  @extend .col-xs-12;
  text-align: center;
  margin-right: -45px;
  @media screen and (max-width: $screen-sm) {
    padding-top: $sp;
  }
}
.subTickets {
  @extend .col-xs-12;
  margin-top: $sp;
}

.popoverActions {
  padding-top: calc($sp / 2);
  text-align: center;
  button {
    min-width: 100px;
  }
}
.popoverContent {
  font-size: 1.3rem;
  padding-top: $sp;
}
.roundButton {
  margin-left: 0.5em;
  border-radius: 200px;
  line-height: 1;
  font-size: 14px;
  padding: 7px 9px;
}
.roundButton:active,
.roundButton:focus {
  outline: none;
}
</style>
